/** Must match `apps/mail/app/lib/open-mailbox-intent.ts`. */
export const WEBMAIL_OPEN_ACCOUNT_KEY = "bafe_webmail_open_account";

export function webmailBaseUrl(): string {
	const configured = import.meta.env.VITE_WEBMAIL_URL?.trim().replace(/\/$/, "");
	if (configured) return configured;
	return `${window.location.origin}/webmail`;
}

/** Default combined mail entry — separate webmail SPA; navigation is a single document load. */
export function webmailInboxUrl(): string {
	return `${webmailBaseUrl()}/mail/all/unread`;
}

/** Uses the Bafe mailbox id — Stalwart account ids may contain `/` and break path routing. */
export function webmailMailboxInboxUrl(mailboxId: string): string {
	return `${webmailBaseUrl()}/mail/${encodeURIComponent(mailboxId)}/inbox?standalone=1`;
}

/** New webmail tabs do not share sessionStorage; localStorage carries the intended mailbox briefly. */
export function rememberWebmailOpenAccount(mailboxId: string): void {
	try {
		localStorage.setItem(WEBMAIL_OPEN_ACCOUNT_KEY, mailboxId);
	} catch {
		// Private mode or blocked storage — URL alone must work.
	}
}
